import * as React from "react";
import Movement from "../../../Elements/Icon/Icons/Movement";
import Notinbed from "../../../Elements/Icon/Icons/Notinbed";
import Fridge from "../../../Elements/Icon/Icons/Fridge";
import Notstoodup from "../../../Elements/Icon/Icons/Notstoodup";
import SelfcheckFail from "../../../Elements/Icon/Icons/Safemate/solid/SelfcheckFail";
import OutdatedPosition from "../../../Elements/Icon/Icons/Safemate/solid/OutdatedPosition";
import PowerOff from "../../../Elements/Icon/Icons/Safemate/solid/PowerOff";
import BatteryQuarter from "../../../Elements/Icon/Icons/Safemate/solid/BatteryQuarter";
import UserIdle from "../../../Elements/Icon/Icons/Safemate/solid/UserIdle";
import CheckCircle from "../../../Elements/Icon/Icons/Safemate/solid/CheckCircle";
import HeadlineAlarm from "@Elements/Icon/Icons/EventSetup/HeadlineAlarm";
import StatusQuestion from "../../../Elements/Icon/Icons/Status/StatusQuestion";
import StatusGeofenceWarning from "../../../Elements/Icon/Icons/Status/StatusGeofenceWarning";
import StatusTcpConnectionDisabled from "../../../Elements/Icon/Icons/Status/StatusTcpConnectionDisabled";
import { AcFail, FallSensor, Tamper } from "@Elements/Icon/Icons/FontAwesome";
import Fire from "@Elements/Icon/Icons/FontAwesome/Fire";
import BatteryEmpty from "@Elements/Icon/Icons/Safemate/solid/BatteryEmpty";
import Epilepsi from "@Elements/Icon/Icons/Epilepsi";
import CircleExclamation from "@Elements/Icon/Icons/CircleExclamation";
import StatusDeepSleep from "@Icons/Status/StatusDeepSleep";

export enum StatusColor{
  UNKNOWN = "unknown",
  FIRE_WARNING = "fire",
  MAN_DOWN_WARNING = "alarm",
  EPILEPSY_WARNING = "epilepsy",
  ALARM_WARNING = "alarm",
  WANDERER_WARNING = "alarm",
  OUT_OF_BED_WARNING = "out-of-bed",
  FRIDGE_WARNING = "fridge",
  IN_BED_WARNING = "in-bed",
  SELF_CHECK_WARNING = "selfcheck",
  OUTDATED_POSITION_WARNING = "selfcheck",
  GEOFENCE_WARNING = "geofenceWarning",
  POWER_FAILURE = "powerFailure",
  BATTERY_WARNING = "lowBattery",
  INACTIVE_WARNING = "lowBattery",
  OUT_OF_BATTERY_WARNING = "lowBattery",
  BATTERY_FAILURE_WARNING = "lowBattery",
  OFFLINE_WARNING = "offline",
  TCP_STATUS_DISABLED_WARNING = "selfcheck",
  DEFAULT = "clear",

  DEFAULT_STATUS = "defaultStatus",
  DEFAULT_ALARM = "defaultAlarm"
}

export enum StatusText{
  LAST_MESSAGE_IN = "unknownStatusHover",
  FIRE_WARNING = "fireStatusHover",
  MAN_DOWN_WARNING = "manDownStatusHover",
  EPILEPSY_WARNING = "epilepsyStatusHover",
  ALARM_WARNING = "alarmStatusHover",
  WANDERER_WARNING = "wandererStatusHover",
  OUT_OF_BED_WARNING = "outOfBedStatusHover",
  FRIDGE_WARNING = "fridgeStatusHover",
  IN_BED_WARNING = "inBedStatusHover",
  SELF_CHECK_WARNING = "selfCheckStatusHover",
  OUT_OF_BATTERY_WARNING = "outOfBatteryStatusHover",
  BATTERY_FAILURE_WARNING = "batteryFailureStatusHover",
  OUTDATED_POSITION_WARNING = "outdatedPositionHover",
  GEOFENCE_WARNING = "geofenceStatusHover",
  POWER_FAILURE = "powerFailureStatusHover",
  BATTERY_WARNING = "batteryStatusHover",
  INACTIVE_WARNING = "staticStatusHover",
  OFFLINE_WARNING = "offlineStatusHover",
  TCP_STATUS_DISABLED_WARNING = "tcpStatusDisabledHover",
  AC_FAIL = "AC_FAIL",
  TAMPER = "TAMPER",
  JAM = "JAM",
  SENSOR_LOW_BATTERY = "apiLowSensorBattery",
  SENSOR_TAMPER = "sensorInfoTamper",
  SENSOR_NOT_FOUND = "sensorNotFound",
  SENSOR_OUT_OF_ORDER = "sensorOutOfOrder",
  SENSOR_CONTROL_ERROR = "sensorControlError",
  DEEP_SLEEP_WARNING = "deepSleepHover",
  DEFAULT = "clearStatusHover"
}

export enum StatusType {
  FIRE_WARNING = "FIRE_WARNING",
  MAN_DOWN_WARNING = "MAN_DOWN_WARNING",
  EPILEPSY_WARNING = "EPILEPSY_WARNING",
  ALARM_WARNING = "ALARM_WARNING",
  WANDERER_WARNING = "WANDERER_WARNING",
  GEOFENCE_WARNING = "GEOFENCE_WARNING",
  SELF_CHECK_WARNING = "SELF_CHECK_WARNING",
  OUT_OF_BED_WARNING = "OUT_OF_BED_WARNING",
  FRIDGE_WARNING = "FRIDGE_WARNING",
  IN_BED_WARNING = "IN_BED_WARNING",
  OUT_OF_BATTERY_WARNING = "OUT_OF_BATTERY_WARNING",
  BATTERY_FAILURE_WARNING = "BATTERY_FAILURE_WARNING",
  OFFLINE_WARNING = "OFFLINE_WARNING",
  DEEP_SLEEP_WARNING = "DEEP_SLEEP_WARNING",
  TCP_STATUS_DISABLED_WARNING = "TCP_STATUS_DISABLED_WARNING",
  OUTDATED_POSITION_WARNING = "OUTDATED_POSITION_WARNING",
  BATTERY_WARNING = "BATTERY_WARNING",
  POWER_FAILURE = "POWER_FAILURE",
  INACTIVE_WARNING = "INACTIVE_WARNING",
  NEVER_USED = "NEVER_USED",
  UNKNOWN_WARNING = "UNKNOWN_WARNING",
  AC_FAIL_WARNING = "AC_FAIL_WARNING",
  JAM_WARNING = "JAM_WARNING",
  TAMPER_WARNING = "TAMPER_WARNING",
  LOW_SENSOR_BATTERY = "LOW_SENSOR_BATTERY",
  SENSOR_TAMPER = "SENSOR_TAMPER",
  SENSOR_NOT_FOUND = "SENSOR_NOT_FOUND",
  SENSOR_OUT_OF_ORDER = "SENSOR_OUT_OF_ORDER",
  SENSOR_CONTROL_ERROR = "SENSOR_CONTROL_ERROR",
  GENERAL_WARNING = "GENERAL_WARNING",
  OK = "OK"
}

export interface DeviceStatus{
  icon: React.ReactElement;
  color: StatusColor;
  text: StatusText;
  metyId?: number[];
}

export interface StatusPriority{
  type: StatusType;
  status: DeviceStatus;
  check?: any;
  priority: number;
  extraCheck?: Array<{ type: StatusType; check: any, priority: number}>;
}

interface StatusIconDefinition{
  [index: string]: DeviceStatus;
}

export const statusIconDefinition: StatusIconDefinition = {
  LAST_MESSAGE_IN: {
    icon: <StatusQuestion/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.LAST_MESSAGE_IN,
  },
  FIRE_WARNING: {
    icon: <Fire/>,
    color: StatusColor.DEFAULT_ALARM,
    text: StatusText.FIRE_WARNING,
    metyId: [27]
  },
  MAN_DOWN_WARNING: {
    icon: <FallSensor large/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.MAN_DOWN_WARNING,
    metyId: [3]
  },
  EPILEPSY_WARNING: {
    icon: <Epilepsi/>,
    color: StatusColor.DEFAULT_ALARM,
    text: StatusText.EPILEPSY_WARNING,
    metyId: [26]
  },
  ALARM_WARNING: {
    icon: <HeadlineAlarm/>,
    color: StatusColor.DEFAULT_ALARM,
    text: StatusText.ALARM_WARNING,
    metyId: [1]
  },
  WANDERER_WARNING: {
    icon: <Movement/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.WANDERER_WARNING,
    metyId: [22]
  },
  OUT_OF_BED_WARNING: {
    icon: <Notinbed/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.OUT_OF_BED_WARNING,
  },
  FRIDGE_WARNING: {
    icon: <Fridge/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.FRIDGE_WARNING
  },
  IN_BED_WARNING: {
    icon: <Notstoodup/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.IN_BED_WARNING
  },
  OUT_OF_BATTERY_WARNING: {
    icon: <BatteryEmpty/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.OUT_OF_BATTERY_WARNING
  },
  BATTERY_FAILURE_WARNING: {
    icon: <BatteryEmpty/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.BATTERY_FAILURE_WARNING
  },
  SELF_CHECK_WARNING: {
    icon: <SelfcheckFail/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SELF_CHECK_WARNING
  },
  OUTDATED_POSITION_WARNING: {
    icon: <OutdatedPosition/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.OUTDATED_POSITION_WARNING
  },
  GEOFENCE_WARNING: {
    icon: <StatusGeofenceWarning/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.GEOFENCE_WARNING,
    metyId: [12, 102]
  },
  POWER_FAILURE: {
    icon: <PowerOff/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.POWER_FAILURE
  },
  BATTERY_WARNING: {
    icon: <BatteryQuarter/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.BATTERY_WARNING
  },
  INACTIVE_WARNING: {
    icon: <UserIdle/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.INACTIVE_WARNING
  },
  OFFLINE_WARNING: {
    icon: <PowerOff/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.OFFLINE_WARNING
  },
  DEEP_SLEEP_WARNING: {
    icon: <StatusDeepSleep/>,
    color: StatusColor.DEFAULT,
    text: StatusText.DEEP_SLEEP_WARNING
  },
  TCP_STATUS_DISABLED_WARNING: {
    icon: <StatusTcpConnectionDisabled/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.TCP_STATUS_DISABLED_WARNING
  },
  AC_FAIL: {
    icon: <AcFail mediumSecondary/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.AC_FAIL
  },
  TAMPER: {
    icon: <Tamper mediumSecondary/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.TAMPER,
  },
  JAM: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.JAM
  },
  SENSOR_LOW_BATTERY: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SENSOR_LOW_BATTERY
  },
  SENSOR_TAMPER: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SENSOR_TAMPER
  },
  SENSOR_OUT_OF_ORDER: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SENSOR_OUT_OF_ORDER
  },
  SENSOR_CONTROL_ERROR: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SENSOR_CONTROL_ERROR
  },
  SENSOR_NOT_FOUND: {
    icon: <CircleExclamation/>,
    color: StatusColor.DEFAULT_STATUS,
    text: StatusText.SENSOR_NOT_FOUND
  },
  DEFAULT: {
    icon: <CheckCircle/>,
    color: StatusColor.DEFAULT,
    text: StatusText.DEFAULT
  }
}

export const statusPriority: Array<StatusPriority> = [
  { type: StatusType.UNKNOWN_WARNING, check: null, priority: 1,
    status: statusIconDefinition.LAST_MESSAGE_IN
  },
  { type: StatusType.FIRE_WARNING, check: true, priority: 2, 
    status: statusIconDefinition.FIRE_WARNING
  },
  { type: StatusType.MAN_DOWN_WARNING, check: true, priority: 3, 
    status: statusIconDefinition.MAN_DOWN_WARNING
  },
  { type: StatusType.EPILEPSY_WARNING, check: true, priority: 4, 
    status: statusIconDefinition.EPILEPSY_WARNING
  },
  { type: StatusType.ALARM_WARNING, check: true, priority: 5, 
    status: statusIconDefinition.ALARM_WARNING
  },
  { type: StatusType.WANDERER_WARNING, check: true, priority: 6, 
    status: statusIconDefinition.WANDERER_WARNING
  },
  { type: StatusType.GEOFENCE_WARNING, check: true, priority: 7,
    status: statusIconDefinition.GEOFENCE_WARNING
  },
  { type: StatusType.SELF_CHECK_WARNING, check: true, priority: 8, 
    status: statusIconDefinition.SELF_CHECK_WARNING
  },
  { type: StatusType.OUT_OF_BED_WARNING, check: true, priority: 9, 
    status: statusIconDefinition.OUT_OF_BED_WARNING
  },
  { type: StatusType.FRIDGE_WARNING, check: true, priority: 10, 
    status: statusIconDefinition.FRIDGE_WARNING
  },
  { type: StatusType.IN_BED_WARNING, check: true, priority: 11, 
    status: statusIconDefinition.IN_BED_WARNING
  },
  { type: StatusType.OUT_OF_BATTERY_WARNING, check: true, priority: 12, 
    status: statusIconDefinition.OUT_OF_BATTERY_WARNING
  },
  { type: StatusType.BATTERY_FAILURE_WARNING, check: true, priority: 12,
    status: statusIconDefinition.BATTERY_FAILURE_WARNING
  },
  { type: StatusType.OFFLINE_WARNING, check: true, priority: 13,
    status: statusIconDefinition.OFFLINE_WARNING
  },
  { type: StatusType.DEEP_SLEEP_WARNING, check: true, priority: 14,
    status: statusIconDefinition.DEEP_SLEEP_WARNING
  },
  { type: StatusType.TCP_STATUS_DISABLED_WARNING, check: true, priority: 15,
    status: statusIconDefinition.TCP_STATUS_DISABLED_WARNING
  },
  { type: StatusType.OUTDATED_POSITION_WARNING, check: true, priority: 16,
    status: statusIconDefinition.OUTDATED_POSITION_WARNING
  },
  { type: StatusType.BATTERY_WARNING, check: true, priority: 16,
    status: statusIconDefinition.BATTERY_WARNING
  },
  { type: StatusType.POWER_FAILURE, check: true, priority: 18,
    status: statusIconDefinition.POWER_FAILURE
  },
  { type: StatusType.INACTIVE_WARNING, check: true, priority: 19,
    status: statusIconDefinition.INACTIVE_WARNING
  },
  { type: StatusType.AC_FAIL_WARNING , check: true, priority: 19,
    status: statusIconDefinition.AC_FAIL
  },
  { type: StatusType.JAM_WARNING , check: true, priority: 20,
    status: statusIconDefinition.JAM
  },
  { type: StatusType.TAMPER_WARNING , check: true, priority: 21,
    status: statusIconDefinition.TAMPER
  },
  { type: StatusType.LOW_SENSOR_BATTERY , check: true, priority: 22,
    status: statusIconDefinition.SENSOR_LOW_BATTERY
  },
  { type: StatusType.SENSOR_TAMPER, check: true, priority: 23,
    status: statusIconDefinition.SENSOR_TAMPER
  },
  { type: StatusType.SENSOR_NOT_FOUND, check: true, priority: 24,
    status: statusIconDefinition.SENSOR_NOT_FOUND
  },
  { type: StatusType.SENSOR_OUT_OF_ORDER, check: true, priority: 25,
    status: statusIconDefinition.SENSOR_OUT_OF_ORDER
  },
  { type: StatusType.SENSOR_CONTROL_ERROR, check: true, priority: 26,
    status: statusIconDefinition.SENSOR_CONTROL_ERROR
  },
  { type: StatusType.OK, priority: 100,
    status: statusIconDefinition.DEFAULT
  }
]

export const getStatusByMetyId = (metyId: number): DeviceStatus | null => {
  for(const key in statusIconDefinition){
    if(statusIconDefinition[key].metyId && statusIconDefinition[key].metyId.includes(metyId)){
      return statusIconDefinition[key];
    }
  }
}
